var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book-copy"},[_c('a',{on:{"click":_vm.addBookCopy}},[_vm._v("Add book copy")]),_vm._v(" "),_c('TaskAddModal',{attrs:{"show":_vm.showModal,"parentBook":_vm.currentBookMeta},on:{"closed":_vm.taskAddModalClose}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6acadf8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/details/BookCopy.vue
// module id = 1029
// module chunks = 6